import { render, staticRenderFns } from "./AccountBarCard.vue?vue&type=template&id=27454d8f"
import script from "./AccountBarCard.vue?vue&type=script&lang=js"
export * from "./AccountBarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports